import { useTranslate } from "../../../../../hooks/useTranslate";
import { MinRateCapacityReason } from "../helpers/calculateMaximumPurchasableTicketsForRate";

export type UseRateSoldOutReasonMessageConfig = {
  itemType: "ticket" | "item" | "membership";
  maximumToBuy: number;
  maximumReason: MinRateCapacityReason;
};

export const useRateSoldOutReasonMessage = ({
  itemType,
  maximumToBuy,
  maximumReason,
}: UseRateSoldOutReasonMessageConfig) => {
  const { t } = useTranslate();

  const getTranslationKey = () => {
    const isShop = itemType === "item";
    const isMembership = itemType === "membership";

    const reasonToKeyMap = {
      RateCapacity: isShop ? "shop.maxItemLimitReached" : "tickets.maxRateLimitReached",
      RateLimitPerPurchase: isShop ? "shop.maxItemPerPurchaseReached" : "tickets.maxTicketPerPurchaseReached",
      EventCapacity: isShop
        ? "shop.itemCapacityLimitReached"
        : isMembership
          ? "membership.maxCapacityPerPurchaseReached"
          : "tickets.eventCapacityLimitReached",
      Unknown: isShop ? "shop.itemCapacityLimitReached" : "tickets.eventCapacityLimitReached",
    } as const;
    return reasonToKeyMap[maximumReason];
  };

  const i18nKey = getTranslationKey();

  if (!i18nKey) {
    return "";
  }

  return t("ticketing", i18nKey, {
    seatCount: maximumToBuy,
    maximumToBuy,
  });
};
